import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/ui-brand";

export default function ChooseRole() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  const confirm = async () => {
    try {
      await api.post("/auth/set-role", { rol: "egresado", marca: "Córdoba Crea Futuro" });
      await checkAuth();
      toast.success("Cuenta configurada");
      navigate("/egresado");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    }
  };

  return (
    <Section className="py-14 max-w-lg">
      <h1 className="h-section text-2xl mb-2">Completá tu cuenta</h1>
      <p className="text-sm text-[var(--brand-text-muted)] mb-6">Tu cuenta se configurará como egresado/a de Córdoba Crea Futuro.</p>
      <button onClick={confirm} className="btn-primary w-full" data-testid="choose-confirm">Continuar como egresado/a</button>
      <p className="text-xs text-[var(--brand-text-muted)] mt-4">¿Representás a una empresa? <Link to="/registro?tipo=empresa" className="font-bold text-[var(--brand-accent)]" data-testid="choose-empresa-link">Registrala desde el formulario</Link>.</p>
    </Section>
  );
}
